import React from 'react';

/**
 * ProgressBar - Two-tone progress bar matching Figma Navigation design
 */
export function ProgressBar({ progress = 50, label, height = '8px', className = '' }) {
  const safeProgress = Math.min(100, Math.max(0, progress));

  return (
    <div className={`w-full ${className}`}>
      {label && (
        <div className="flex justify-between items-center text-xs font-semibold text-gray-400 mb-1.5">
          <span>{label}</span>
          <span className="text-[#0EABB0]">{Math.round(safeProgress)}%</span>
        </div>
      )}
      <div 
        style={{ height }}
        className="w-full bg-[#0EABB0]/20 rounded-full overflow-hidden p-0.5 border border-[#0EABB0]/10"
      >
        <div 
          style={{ width: `${safeProgress}%` }}
          className="h-full bg-[#0EABB0] rounded-full transition-all duration-500 ease-out shadow-sm shadow-[#0EABB0]/50"
        />
      </div>
    </div>
  );
}

export default ProgressBar;
